/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type RecommendationType = 'you_might_also_like' | 'popular_in_area' | 'others_also_booked' | 'trending_now';

export interface ClickRecommendationParams {
  recommendation_type: RecommendationType;
  source_experience_slug: string;
  clicked_experience_slug: string;
  position: number;
}

/**
 * 発火タイミング: レコメンドセクション内の体験カードをクリック時。
 * @see docs/Design Doc/自然流入強化-回遊性最適化-レコメンド.md UC6
 */
export const sendGAWabunkaClickRecommendationEvent = (params: { recommendationType: RecommendationType; sourceExperienceSlug: string; clickedExperienceSlug: string; position: number }) => {
  sendWabunkaGAEvent('click_recommendation', {
    recommendation_type: params.recommendationType,
    source_experience_slug: params.sourceExperienceSlug,
    clicked_experience_slug: params.clickedExperienceSlug,
    position: params.position,
  });
};
